import { render, staticRenderFns } from "./FeaturedReservationSummary.vue?vue&type=template&id=b2758680&scoped=true&"
import script from "./FeaturedReservationSummary.vue?vue&type=script&lang=js&"
export * from "./FeaturedReservationSummary.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedReservationSummary.vue?vue&type=style&index=0&id=b2758680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2758680",
  null
  
)

export default component.exports